/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Wed Apr 27 2022
*  File : production.ts
*******************************************/

import { BarrierDisplayMode } from "@api-commons/sdk/aaa/AAABarrierWithSource.js";
import { commonConfig } from "./common.js";

export const config = commonConfig;

config.host = "api.cookist.it";
config.domain = "cookist.it";
config.mainUrl = "https://www.cookist.it";
config.secure = true;
config.debug = true;
config.webPush.serviceWorkerHost = "cookist.it";
config.snhubConfig.domain = "cookist.it";
config.cookies.cookieDomain = ".cookist.it";

config.snhubConfig.secure = true;
config.snhubConfig.host = "api.cookist.it";
config.snhubConfig.enabled = true;

config.ga4.cookieDomain = ".cookist.it";

config.assetsDistro = "https://d18u0p9ui3w1qy.cloudfront.net";

config.loginManager.barrierDisplayMode = BarrierDisplayMode.SHOW_DIALOG;
config.loginManager.actual_providers.email.enabled = true;
config.loginManager.actual_providers.email.codeLoginAllowed = true;


config.nativeApp.dynamicLink.baseUrl = "https://cookist.page.link/app";